
module.exports = { 
      attributes: {},
    
      body: "Mental health services support individuals with a mental health condition. It may be provided by:\n\n- allied health practitioners (e.g., occupational therapist)\n- community mental health care services\n- emergency departments in hospitals\n- general practitioners (GPs)\n- mental health nurse\n- psychiatrists\n- psychologists\n- residential mental health care\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/mental-health-services.md"},
     }